import {Component, ElementRef, EventEmitter, Output, ViewChild, inject} from '@angular/core';
import {NgClass} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-template-midia-escolha',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './template-midia-escolha.component.html',
  styleUrl: './template-midia-escolha.component.css'
})
export class TemplateMidiaEscolhaComponent {
  private readonly sanitizer = inject(DomSanitizer);

  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

  @Output() envioArquivo = new EventEmitter<any>();
  @Output() envioFormato = new EventEmitter<string>();

  selecionouMidia = false;

  midiaSelcionada = {
    foto: false,
    video: false,
    document: false,
    map: false
  };

  arquivoSelecionado: any;

  selecionarMidia(midiaSelcionada: number) {
    switch(midiaSelcionada) {
      case 1:
        this.midiaSelcionada.foto = true;
        this.midiaSelcionada.video = false;
        this.midiaSelcionada.document = false;
        this.midiaSelcionada.map = false;
        this.envioFormato.emit('IMAGE');
        break;
      case 2:
        this.midiaSelcionada.foto = false;
        this.midiaSelcionada.video = true;
        this.midiaSelcionada.document = false;
        this.midiaSelcionada.map = false;
        this.envioFormato.emit('VIDEO');
        break;
      case 3:
        this.midiaSelcionada.foto = false;
        this.midiaSelcionada.video = false;
        this.midiaSelcionada.document = true;
        this.midiaSelcionada.map = false;
        this.envioFormato.emit('DOCUMENT');
        break;
      case 4:
        this.midiaSelcionada.foto = false;
        this.midiaSelcionada.video = false;
        this.midiaSelcionada.document = false;
        this.midiaSelcionada.map = true;
        this.envioFormato.emit('MAP');
        break;
    }
    this.selecionouMidia = true;
  }

  anexar(){
    const input = this.fileInputRef.nativeElement;

    if(this.midiaSelcionada.foto){
      input.accept = 'image/*';
    }
    else if(this.midiaSelcionada.video){
      input.accept = 'video/*';
    }
    else if(this.midiaSelcionada.document){
      input.accept = '.pdf,.txt';
    }
    else if(this.midiaSelcionada.map){
      input.accept = '.geojson,.kml,.shp';
    }
    input.click();
  }

  buscarArquivo(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64 = reader.result as string;
        this.envioArquivo.emit({ file, base64 });
      };
      reader.readAsDataURL(file);
    }
  }

}
